export function Logo({ size = 40, withText = true }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="gold" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor="#f0d79a" />
            <stop offset="100%" stopColor="#D3A84E" />
          </radialGradient>
        </defs>
        <circle cx="32" cy="32" r="30" stroke="#D3A84E" strokeWidth="1.5" opacity="0.5" />
        <path d="M44 32a13 13 0 1 1-9.5-12.5A10 10 0 0 0 44 32Z" fill="url(#gold)" />
        <path d="M46 14l1.6 4.2L52 20l-4.4 1.8L46 26l-1.6-4.2L40 20l4.4-1.8L46 14Z" fill="#E7D9F2" />
        <circle cx="18" cy="44" r="1.6" fill="#E7D9F2" />
        <circle cx="50" cy="42" r="1.2" fill="#D3A84E" />
      </svg>
      {withText && (
        <div className="leading-tight">
          <div className="font-serif text-lg font-semibold text-celeste-ivoire">Guidance Céleste</div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-celeste-or">Essences Céleste · Live</div>
        </div>
      )}
    </div>
  );
}
